import { createAction } from 'redux-actions-helpers'

export const createModule = createAction(
  '@@admin-create-module/CREATE_MODULE',
  (id: string, title: string, position: number, available_at: string): any => ({
    id,
    title,
    position,
    available_at,
  })
)

export const createModuleSuccess = createAction(
  '@@admin-create-module/CREATE_MODULE_SUCCESS'
)

export const createModuleFailure = createAction(
  '@@admin-create-module/CREATE_MODULE_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-create-module/DESTROY')
